export default __webpack_public_path__ + "static/media/bg-campaign-2.47cd9462.png";